import * as React from 'react';
// import SwipeableViews from 'react-swipeable-views';
import Carousel from 'react-material-ui-carousel';

import Box from '@mui/material/Box';

import Image1 from '../../assets/card-1.jpg';
// import Image2 from '../../assets/card-2.jpg';
import Image3 from '../../assets/card-3.jpg';
import Image4 from '../../assets/card-4.jpg';
import Image5 from '../../assets/card-5.jpg';

// Testimonial 2025
/*
const TestimonialNodes = [{
    title: "",
    desc1: "My Sea Finance MA journey has been a fulfilling voyage with great opportunities to work alongside the different teams in Finance, providing a real breadth of exposure. The experience in each rotation has helped me to realize how different parts of the Finance ecosystem work together. Our trust in people and their abilities has instilled the confidence in me to explore, learn and grow as a person, and professionally, enabling me to ride on the waves as I sail further in my career.",
    desc2: "",
    desc3: "",
    name: "Teh Yong Wei, Graduated FMA, 2020",
    position1: "Nanyang Technological University, Accounting and Banking & Finance",
    position2: "",
    position3: "",
    img: Image1,
    bgColor: '#000084'
},{
    title: "",
    desc1: "As an FMA, I was entrusted with leading challenging yet impactful projects that contributed to the team’s success. The autonomy and support from my colleagues gave me the space to grow while making meaningful contributions. This voyage inspired me to take the helm in driving initiatives, thinking critically, and collaborating across functions—experiences that were rewarding and that equipped me to navigate the journey forward.",
    desc2: "",
    desc3: "",
    name: "Leslie Lee, FMA 2020",
    position1: "Nanyang Technological University, Accountancy and Banking & Finance",
    position2: "",
    position3: "",
    img: Image2,
    bgColor: '#478EF7'
},{
    title: "",
    desc1: "My experience so far as an FMA has been very fulfilling! Sailing through the dynamic economic environment brought both rewards and challenges. The opportunities to explore various functions not only gave me a comprehensive understanding of the finance department, but also challenged me to learn and contribute quickly. Most importantly, the supportive environment and mentorship also fueled my continuous growth and learning in my professional career.",
    desc2: "",
    desc3: "",
    name: "Lim Sze Leng, FMA 2022",
    position1: "Singapore Management University, Accountancy",
    position2: "",
    position3: "",
    img: Image3,
    bgColor: '#00E8FF'
}];
*/
const TestimonialNodes = [{
    title: "",
    desc1: "My voyage as an FMA has been incredibly fulfilling. Through my rotations, I’ve worked across different Finance teams, gaining a broader understanding of how each function drives the wider business. Each rotation has challenged me to adapt quickly, take ownership of meaningful work, and think critically about how data and technology can evolve our decision-making. Most importantly, the guidance from my mentors and colleagues has enriched the experience. As I continue through the program, I am incredibly grateful for the trust and exposure that have helped me grow both professionally and personally.",
    desc2: "",
    desc3: "",
    name: "Ang Teng Xuan (James), FMA 2025",
    position1: "Nanyang Technological University, Accountancy",
    position2: "",
    position3: "",
    img: Image4,
    bgColor: '#478EF7'
},{
    title: "",
    desc1: "The FMA program gave me an expansive view of Finance, spanning the nuances of different business segments, hands-on accounting and reporting work, and project managing system and data initiatives. Rotating across functions helped me genuinely appreciate how each piece fits into the bigger picture. That breadth has proven invaluable in my current role, where I cover tax, accounting systems, and management reporting, and work closely with local teams and stakeholders in different functions. The FMA journey built my technical grounding and gave me the adaptability and confidence to navigate the unexpected.",
    desc2: "",
    desc3: "",
    name: "Zhang Yiqian, Graduated FMA, 2022",
    position1: "Nanyang Technological University, Accountancy and Banking & Finance",
    position2: "",
    position3: "",
    img: Image5,
    bgColor: '#000084'
},{
    title: "",
    desc1: "My experience so far as an FMA has been very fulfilling! Sailing through the dynamic economic environment brought both rewards and challenges. The opportunities to explore various functions not only gave me a comprehensive understanding of the finance department, but also challenged me to learn and contribute quickly. Most importantly, the supportive environment and mentorship also fueled my continuous growth and learning in my professional career.",
    desc2: "",
    desc3: "",
    name: "Lim Sze Leng, Graduated FMA, 2022",
    position1: "Singapore Management University, Accountancy",
    position2: "",
    position3: "",
    img: Image3,
    bgColor: '#478EF7'
},{
    title: "",
    desc1: "My Sea Finance MA journey has been a fulfilling voyage with great opportunities to work alongside the different teams in Finance, providing a real breadth of exposure. The experience in each rotation has helped me to realize how different parts of the Finance ecosystem work together. Our trust in people and their abilities has instilled the confidence in me to explore, learn and grow as a person, and professionally, enabling me to ride on the waves as I sail further in my career.",
    desc2: "",
    desc3: "",
    name: "Teh Yong Wei, Graduated FMA, 2020",
    position1: "Nanyang Technological University, Accounting and Banking & Finance",
    position2: "",
    position3: "",
    img: Image1,
    bgColor: '#000084'
}];

function CarouselCard(props){
    return(
        <Box className="card">
            <Box className="content-desc" sx={{
                        backgroundColor:`${props.item.bgColor}`,
                        // '@media(max-width: 821px)': {
                        //     backgroundColor:'#fff',
                        //     color: 'rgba(0,0,0,.54)'
                        // }
                        }}>
                <Box className="content-desc-text">
                <h4 className="title">{props.item.title}</h4>
                <p className="desc">{props.item.desc1}</p>
                {/* <p className="desc">{props.item.desc2}</p>
                <p className="desc">{props.item.desc3}</p> */}
                <p className="name">{props.item.name}</p>
                <p className="position">{props.item.position1}</p>
                {/* <p className="position">{props.item.position2}</p>
                <p className="position">{props.item.position3}</p> */}
                </Box>
            </Box>
            <Box className="content-img" sx={{background: `url(${props.item.img}) center 0 no-repeat;`}}>
                <Box className="content-img-linear"></Box>            
            </Box>
        </Box>
    )
}

export default function Testimonial(){
    return (
        <Box className="testimonial">
            <h2 className="section-title">Life @ Sea Finance!</h2>
            <Box className="carousel-wrapper">
                <Box className="carousel">

                    <Carousel animation="slide" indicators={false} interval='3000' duration='700' navButtonsAlwaysVisible={true} 
                        navButtonsWrapperProps={{
                            style: {
                                margin: '10px'
                            },
                            className : "nav-button-wrapper"
                        }}
                        navButtonsProps={{
                            style: {
                                backgroundColor: 'transparent',
                                color:'black',
                            }
                        }} > 
                        {
                            TestimonialNodes.map( (item,i) => <CarouselCard key={i} item={item} /> )
                        }
                    </Carousel>

                </Box>
            </Box>
        </Box>
            
    );
}